import React from 'react'

interface PlafondWarningProps {
    show: boolean
}

const PlafondWarning: React.FC<PlafondWarningProps> = ({ show }) => {
    if (!show) return null

    return (
        <div>
            <i className="fa fa-exclamation-triangle text-warning mr-2" />
            Le plafond de remise Vendeurs est supérieur au plafond de remise Chefs des ventes
        </div>
    )
}

export default PlafondWarning
